import React from 'react'
import { ViewersExpandableChartProps } from './ViewersExpandableChart.types'
import styles from './ViewersExpandableChart.module.scss'
import cl from 'classnames'
import { ExpandableBarChart } from 'pages/statistics/common'
import { DualAxis } from '../DualAxis'

const ViewersExpandableChartComponent = (props: ViewersExpandableChartProps) => {
  const {
    className,
    style,
    chartHeaderProps,
    initialChartVisibility,
    chartData
  } = props

  return (
    <ExpandableBarChart
      className={cl(styles.container, className)}
      style={style}
      chartHeaderProps={chartHeaderProps}
      initialChartVisibility={initialChartVisibility}
    >
      <DualAxis data={chartData} />
    </ExpandableBarChart>
  )
}

const ViewersExpandableChart = ViewersExpandableChartComponent
export { ViewersExpandableChart }
